import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../contexts/LanguageContext';
export function SocialFooter() {
  const {
    t
  } = useLanguage();
  const socialPosts = [{
    image: 'https://images.unsplash.com/photo-1547592166-23ac45744acd?w=400&h=400&fit=crop',
    alt: 'NeuroSpice jar on kitchen counter',
    link: 'https://instagram.com/thisisneurospice'
  }, {
    image: 'https://images.unsplash.com/photo-1556910103-1c02745aae4d?w=400&h=400&fit=crop',
    alt: 'User testimonial about mental wellness',
    link: 'https://instagram.com/thisisneurospice'
  }, {
    image: 'https://images.unsplash.com/photo-1512621776951-a57141f2eefd?w=400&h=400&fit=crop',
    alt: 'Healthy meal with NeuroSpice',
    link: 'https://instagram.com/thisisneurospice'
  }, {
    image: 'https://images.unsplash.com/photo-1544025162-d76694265947?w=400&h=400&fit=crop',
    alt: 'Community impact story',
    link: 'https://instagram.com/thisisneurospice'
  }, {
    image: 'https://images.unsplash.com/photo-1490818387583-1baba5e638af?w=400&h=400&fit=crop',
    alt: 'Therapy fund milestone',
    link: 'https://instagram.com/thisisneurospice'
  }, {
    image: 'https://images.unsplash.com/photo-1511690656952-34342bb7c2f2?w=400&h=400&fit=crop',
    alt: 'Behind the scenes at NeuroSpice',
    link: 'https://instagram.com/thisisneurospice'
  }];
  return <section className="w-full py-20 px-6 bg-white border-t-2 border-black" data-id="element-351">
      <div className="max-w-6xl mx-auto" data-id="element-352">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-353">
          <h3 className="text-4xl md:text-6xl font-black text-black mb-4 uppercase tracking-tighter" data-id="element-354">
            {t('social.title')}
          </h3>
          <p className="text-gray-600 font-mono" data-id="element-355">{t('social.handle')}</p>
        </motion.div>
        <div className="grid grid-cols-2 md:grid-cols-3 gap-4" data-id="element-356">
          {socialPosts.map((post, index) => <motion.a key={index} href={post.link} target="_blank" rel="noopener noreferrer" initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="relative aspect-square overflow-hidden border-2 border-black group cursor-pointer" data-id="element-357">
              <img src={post.image} alt={post.alt} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" data-id="element-358" />
              <div className="absolute inset-0 bg-black/0 group-hover:bg-black/70 transition-all duration-300 flex items-center justify-center" data-id="element-359">
                <div className="opacity-0 group-hover:opacity-100 transition-opacity duration-300" data-id="element-360">
                  <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-361">
                    <rect x="2" y="2" width="20" height="20" rx="5" ry="5" data-id="element-362" />
                    <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" data-id="element-363" />
                    <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" data-id="element-364" />
                  </svg>
                </div>
              </div>
            </motion.a>)}
        </div>
      </div>
    </section>;
}